/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'screen_shield': {
    width: 16,
    height: 16,
    viewBox: '0 0 34.68 41',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" _fill="none" _stroke="#383e47" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 38.99H1V1h32.68v23.11"/><path pid="1" _fill="none" _stroke="#383e47" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.37 20l6.25-8.8 6.08 7.06 6.64-9.37M33.68 28.15A14.12 14.12 0 0127.24 40a14.12 14.12 0 01-6.44-11.85l6.44-1.86z"/><circle pid="2" cx="27.24" cy="32.33" r="2.97" _fill="#e15053"/></g></g>'
  }
})
